export default __webpack_public_path__ + "static/media/caret-circle-down.5822b803.svg";